import React, {useRef} from "react"
import gsap from 'gsap';
import style from "./index.module.less"
import ArrowRightW from '@/images/SVG/arrow-right-w.svg'
import useNavigate from '@/hooks/useNavigate'

const LearnBuyBtn = ({ btnText, btnType, link, link_out }) => {
  const arrowRightRef = useRef();
  const btnTextRef = useRef();
  const glowWrapperRef = useRef();
  const navigate = useNavigate;

  const btnClass = {
    learn: {
      sty: style.btnMore,
      bgColor1: 'linear-gradient(to right, rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0.3))',
      bgColor2: 'linear-gradient(to right, rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0.1))'
    },
    
    buy: {
      sty: style.btnBuy,
      bgColor1: 'linear-gradient(to top, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0))',
      bgColor2: 'linear-gradient(to top, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0))'
    }
  }

  const handleMouseEnter = () => {
    // icon和文字
    gsap.set(arrowRightRef.current, { display: 'flex' }); // 先设置显示
    gsap.fromTo(
      arrowRightRef.current,
      { opacity: 0 },
      { opacity: 1, duration: 0.6, ease: 'power1.in' }
    );
    gsap.to(btnTextRef.current, {
      x: -7,
      duration: 0.4,
      ease: 'power2.out',
    });

    // 背景色
    gsap.set(glowWrapperRef.current, { background: btnClass[btnType].bgColor1 }); // 先设置显示
    gsap.to(glowWrapperRef.current, {
      background: btnClass[btnType].bgColor1,
      duration: 0.5, // 动画持续时间
      ease: 'power2.inOut' // 缓动效果
    });
  };

  const handleMouseLeave = () => {

    // icon和文字
    gsap.to(arrowRightRef.current, {
      opacity: 0,
      duration: 0.6,
      ease: 'circ.out'
    });
    gsap.to(btnTextRef.current, {
      x: 0,
      duration: 0.4,
      ease: 'power2.inOut',
    });

    //背景色
    gsap.to(glowWrapperRef.current, {
      background: btnClass[btnType].bgColor2,
      duration: 0.5,
      ease: 'power2.inOut'
    });
  };

  const goLink = () => {
        
    if (link_out) {
      window.open(link)
    } else {
      navigate(link) 
    }
  }

  return (

    <div
      ref={glowWrapperRef}
      className={`${style.glowWrapper} ${btnClass[btnType].sty}`}
      onMouseEnter={() => handleMouseEnter()}
      onMouseLeave={() => handleMouseLeave()}
      onClick={() => goLink()}
    >
      <div className={`${style.btnContent}`}>
        <div ref={btnTextRef} className={style.btnText}>{ btnText }</div>
        <div ref={arrowRightRef} className={style.arrowSvg}><ArrowRightW /></div>
      </div>
      
    </div>
  )
}

export default LearnBuyBtn
